import { Box, Button, Center, Container, Group, Stack, Text } from '@mantine/core';
import StadiumIcon from '../../components/icons/Stadium';
import { useSeatingChart } from './SeatingChart.hooks';
import { BNButton } from '../../components/Button/Button';
import classes from './SeatingChart.module.css';
import OpenNewIcon from '../../components/icons/OpenNew';
import { useGlobalState } from '../../data/Global.state';
import { useNavigate } from 'react-router-dom';

export function EmptyState() {
  const { setShowEventMapping, closeMarketplaceLinks, setIsMarketSelectorOpen } = useSeatingChart('setShowEventMapping', 'closeMarketplaceLinks', 'setIsMarketSelectorOpen',);
  const { isMobile } = useGlobalState('isMobile');
  const navigate = useNavigate();
  return (
    <>
      <Box className={isMobile ? undefined : classes.emptyStateOuterWrapper}>
        <Container p={0} className={classes.emptyStateWrapper}>
          <Center className={classes.center}>
            <Box className={classes.iconWrapper}>
              <StadiumIcon color="var(--colors-iconFill)" size={28} />
            </Box>
            <Text size="md" fw={600}>
              Event Not Mapped To Marketplace
            </Text>
                <Group gap={0}>
                  <Text size="xs" c="var(--colors-gray-5)">
                    Click below to map this event to the marketplace
                  </Text>
                </Group>
                <Stack gap="sm" mt="md">
                  <BNButton
                    size="xs"
                    variant="filled"
                    color="green"
                    onClick={() => {
                      setIsMarketSelectorOpen(false);
                      closeMarketplaceLinks();
                      if (isMobile) { navigate('../eventmapping', { relative: 'path' }); } else { setShowEventMapping((x) => !x); }
                    }}
                    data-pendo-name="Update Event Mapping Button"
                  >
                    Update Event Mapping
                  </BNButton>
                  <Button
                    size="xs"
                    variant="default"
                    component="a"
                    href="https://vimeo.com/842993175"
                    target="_blank"
                    rightSection={<OpenNewIcon />}
                    data-pendo-name="Event Mapping Video Button"
                  >
                    Video Tutorial
                  </Button>
                </Stack>
          </Center>
        </Container>
      </Box>
    </>
  );
}
